<script>
import ContentTabbed from '@/components/common/content/ContentTabbed'
import {STATUS_DRAFT} from '@/assets/js/api/requests/private/movements'
import {mapState} from 'vuex'
import MovementsStoresListInfinityScroll from '@/components/requests/stores/movements/list/MovementsStoresListInfinityScroll'
import MovementsStoresListItem from '@/components/requests/stores/movements/list/MovementsStoresListItem'

export default {
  extends: ContentTabbed,

  props: {
    accountId: Number,
  },

  computed: {
    ...mapState('requests', [
      'summary',
    ]),

    canCreate() {
      return !this.$auth.impersonating()
    },

    formRoute() {
      return {name: 'accounts.stores.details.requests.movements.create'}
    },

    tabs() {
      return [
        {
          key: 'history',
          bind: {
            filters: {account: this.accountId, status__exclude: [STATUS_DRAFT]},
            hideCaptions: false,
            listItemComponent: MovementsStoresListItem,
          },
          component: MovementsStoresListInfinityScroll,
          title: 'История',
        },
        {
          key: 'drafts',
          bind: {
            filters: {account: this.accountId, status: [STATUS_DRAFT]},
            hideCaptions: true,
            listItemComponent: MovementsStoresListItem,
          },
          component: MovementsStoresListInfinityScroll,
          title: 'Черновики',
        },
      ]
    },
  },
}
</script>